import axiosPost from "./axiosPost";

export const RNHUnidadIns = async (credentials, data) => {
    const body = {
        service: "RNHUnidadIns",
        params: {
            rnhUnidadCod: data?.cod || null,
            rnhUnidadNombre: data?.name || null,
            rnhUnidadDescripcion: data?.desc || null
        },
    };

    const result = await axiosPost(body, credentials);
    if(result?.status?.code === 0) {
        return [result.status]
    } else {
        return result.result;
    }
};
